import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
export function AppShellAdmin({ brand, convenioSlot, topbarSlot, sidebarFooter, nav, activeKey, activeHref, onNavigate, children, }) {
    return (_jsxs("div", { style: {
            height: "100vh",
            display: "grid",
            // `minmax(0, 1fr)` e nao `1fr`: um item de grid tem `min-width: auto`,
            // entao uma tabela larga esticaria a coluna `main` para alem da tela e
            // o `overflow: hidden` desta caixa CORTARIA o excesso — sem barra
            // nenhuma para alcanca-lo. Com o minimo em zero, a coluna para de
            // crescer e quem rola e' o quadro da tabela (feature 008, FR-038).
            gridTemplateColumns: "260px minmax(0, 1fr)",
            gridTemplateRows: "64px 1fr",
            gridTemplateAreas: `"sidebar topbar" "sidebar main"`,
            background: "var(--bg)",
            color: "var(--text)",
            overflow: "hidden",
        }, children: [_jsxs("aside", { style: {
                    gridArea: "sidebar",
                    background: "var(--bg-elev)",
                    borderRight: "1px solid var(--border)",
                    display: "flex",
                    flexDirection: "column",
                    minHeight: 0,
                }, children: [_jsxs("div", { style: { padding: "20px 16px 12px", display: "flex", flexDirection: "column", gap: 16, flexShrink: 0 }, children: [brand, convenioSlot] }), _jsx("nav", { className: "atlas-hide-scrollbar", style: {
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            padding: "0 16px 20px",
                            overflowY: "auto",
                            flex: 1,
                            minHeight: 0,
                        }, children: nav.map((item) => (_jsx(NavLeaf, { item: item, activeKey: activeKey, activeHref: activeHref, onNavigate: onNavigate }, item.href ?? item.key))) }), sidebarFooter ? (_jsx("div", { style: {
                            flexShrink: 0,
                            padding: "12px 16px 16px",
                            borderTop: "1px solid var(--border)",
                        }, children: sidebarFooter })) : null] }), _jsx("header", { style: {
                    gridArea: "topbar",
                    borderBottom: "1px solid var(--border)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "0 24px",
                    background: "color-mix(in srgb, var(--bg) 80%, transparent)",
                    backdropFilter: "blur(12px)",
                }, children: topbarSlot }), _jsx("main", { className: "atlas-hide-scrollbar", style: { gridArea: "main", padding: 24, overflowY: "auto" }, children: children })] }));
}
/**
 * Contador de pendencias do item de menu.
 *
 * Centralizacao: `inline-flex` + `center` nos dois eixos e `lineHeight: 1`.
 * Sem o lineHeight fixo o glifo herda a entrelinha do botao (14px/normal) e o
 * numero desce alguns pixels dentro do circulo — o "torto" da referencia.
 * `minWidth === height` mantem o circulo redondo em 1 digito e o transforma em
 * pilula a partir de 2, sem esmagar o numero.
 */
function NavBadge({ value }) {
    return (_jsx("span", { "aria-label": `${value} aguardando aprovação`, style: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: 20,
            height: 20,
            padding: "0 6px",
            borderRadius: 999,
            background: "var(--danger-500)",
            color: "#FFFFFF",
            fontSize: 11,
            fontWeight: 700,
            lineHeight: 1,
            fontVariantNumeric: "tabular-nums",
            flexShrink: 0,
        }, children: value > 99 ? "99+" : value }));
}
function NavLeaf({ item, activeKey, activeHref, onNavigate, depth = 0, }) {
    // Regra de highlight:
    // - Se activeHref foi informado E o item tem href, casa por href (URL corrente).
    //   Isso desambigua itens que compartilham `key` (dois "Portabilidade" no
    //   sidebar do banco, por exemplo).
    // - Senao, cai no match por key (comportamento historico — usado quando o
    //   item nao tem href proprio ou o pai chamou sem activeHref).
    const isActive = activeHref && item.href
        ? item.href === activeHref
        : activeKey === item.key;
    const [open, setOpen] = useState(item.children?.some((c) => (activeHref && c.href ? c.href === activeHref : c.key === activeKey)) ?? false);
    const hasChildren = !!item.children?.length;
    const baseStyle = {
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: `10px ${12 + depth * 12}px`,
        borderRadius: 10,
        fontSize: 14,
        fontWeight: isActive ? 600 : 500,
        color: isActive ? "var(--accent)" : "var(--text-muted)",
        background: isActive ? "var(--bg-elev-2)" : "transparent",
        cursor: item.disabled ? "not-allowed" : "pointer",
        opacity: item.disabled ? 0.45 : 1,
        border: "none",
        width: "100%",
        textAlign: "left",
        transition: "background .15s, color .15s",
    };
    return (_jsxs(_Fragment, { children: [_jsxs("button", { type: "button", style: baseStyle, "aria-disabled": item.disabled ? true : undefined, title: item.title, onClick: () => {
                    if (item.disabled)
                        return;
                    if (hasChildren) {
                        setOpen((o) => !o);
                        return;
                    }
                    onNavigate?.(item);
                }, onMouseEnter: (e) => {
                    if (!isActive && !item.disabled)
                        e.currentTarget.style.background = "var(--bg-elev-2)";
                }, onMouseLeave: (e) => {
                    if (!isActive)
                        e.currentTarget.style.background = "transparent";
                }, children: [item.icon ? _jsx("span", { style: { width: 18, display: "inline-flex" }, children: item.icon }) : null, _jsx("span", { style: { flex: 1 }, children: item.label }), item.badge && item.badge > 0 ? _jsx(NavBadge, { value: item.badge }) : null, hasChildren ? _jsx("span", { style: { fontSize: 10, opacity: 0.6 }, children: open ? "▾" : "▸" }) : null] }), hasChildren && open
                ? item.children.map((child) => (_jsx(NavLeaf, { item: child, activeKey: activeKey, activeHref: activeHref, onNavigate: onNavigate, depth: depth + 1 }, child.href ?? child.key)))
                : null] }));
}
//# sourceMappingURL=AppShellAdmin.js.map